module.exports = __webpack_public_path__ + "html/subscription-invoice-history-table_c639260bb12d8940e451298a5e8733b4.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/subscription-invoice-history-table.html
// module id = H4F6
// module chunks = 55